export default __webpack_public_path__ + "static/media/מועמדים-פוטושופ---סופי_0028s_0000_Black-&-White-33.213f0e5e.png";